import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import api from '../services/api';
import SliderSection from '../components/homepage/SliderSection';
import WelcomeSection from '../components/homepage/WelcomeSection';
import NewsSection from '../components/homepage/NewsSection';
import NoticesSection from '../components/homepage/NoticesSection';
import ServicesSection from '../components/homepage/ServicesSection';
import StatisticsSection from '../components/homepage/StatisticsSection';
import DepartmentsSection from '../components/homepage/DepartmentsSection';
import GallerySection from '../components/homepage/GallerySection';
import './Home.css';

const Home = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadHomepageSections();
  }, []);

  const loadHomepageSections = async () => {
    try {
      const response = await api.get('/homepage-sections/');
      setSections(response.data);
    } catch (error) {
      console.error('Error loading homepage sections:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderSection = (section) => {
    switch (section.section_type) {
      case 'slider':
        return <SliderSection key={section.id} section={section} />;
      case 'welcome':
        return <WelcomeSection key={section.id} section={section} />;
      case 'news':
        return <NewsSection key={section.id} section={section} />;
      case 'notices':
        return <NoticesSection key={section.id} section={section} />;
      case 'services':
        return <ServicesSection key={section.id} section={section} />;
      case 'statistics':
        return <StatisticsSection key={section.id} section={section} />;
      case 'departments':
        return <DepartmentsSection key={section.id} section={section} />;
      case 'gallery':
        return <GallerySection key={section.id} section={section} />;
      case 'custom_html':
        return (
          <section key={section.id} className={`homepage-section ${section.css_class}`}>
            <Container>
              <div dangerouslySetInnerHTML={{ __html: section.content }} />
            </Container>
          </section>
        );
      default:
        return null;
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <div className="homepage">
      {sections.map(section => renderSection(section))}
    </div>
  );
};

export default Home;
